<template>
	<div data-test="session-container" class="flex flex-col flex-grow w-full h-full bg-white dark:bg-gray-700">
		<slot name="pre-header" />
		<AppHeader class="header-grid dark bg-gray-900 mobile:hidden border-gray-800 text-gray-100">
			<div class="flex items-center">
				<slot name="header-start" />
			</div>
			<div class="flex items-center justify-center">
				<slot name="header-middle" />
			</div>
			<div class="flex justify-end items-center">
				<slot name="header-end" />
			</div>
		</AppHeader>
		<slot />
	</div>
</template>

<script>
import AppHeader from 'shared/components/AppHeader.vue'

export default {
	name: 'SessionContainer',
	components: {
		AppHeader,
	},
}
</script>

<style scoped>
.header-grid {
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	gap: 24px;
}
</style>
